import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ATTSCHEDULE,
  DELETE_ATTSCHEDULE,
  UPDATE_ATTSCHEDULE,
  ADD_NEW_ATTSCHEDULE,
} from "./actionType";

import {
  getAttScheduleSuccess,
  getAttScheduleFail,
  deleteAttScheduleSuccess,
  deleteAttScheduleFail,
  updateAttScheduleSuccess,
  updateAttScheduleFail,
  addAttScheduleSuccess,
  addAttScheduleFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAttScheduleApi,
  getAttScheduleApi,
  updateAttScheduleApi,
  deleteAttScheduleApi,
  addNewAttScheduleApi
} from "../../helpers/backend_helper";

function* getAttSchedule({ payload: attSchedule }) {
  try {
    const response = yield call(getAttScheduleApi, attSchedule);
    yield put(getAttScheduleSuccess(GET_ATTSCHEDULE, response.data));
  } catch (error) {
    yield put(getAttScheduleFail(GET_ATTSCHEDULE, error));
  }
}

function* onUpdateAttSchedule({ payload: attSchedule }) {
  try {
    if (attSchedule.setApprove) {
      const response = yield call(approveAttScheduleApi, attSchedule);
      yield put(updateAttScheduleSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAttScheduleApi, attSchedule);
      yield put(updateAttScheduleSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAttScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAttSchedule({ payload: attSchedule }) {
  try {
    const response = yield call(deleteAttScheduleApi, attSchedule);
    yield put(deleteAttScheduleSuccess({ attSchedule, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAttScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAttSchedule({ payload: attSchedule }) {
  try {
    const response = yield call(addNewAttScheduleApi, attSchedule);
    yield put(addAttScheduleSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAttScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAttSchedule() {
  yield takeEvery(GET_ATTSCHEDULE, getAttSchedule);
}

export function* watchUpdateAttSchedule() {
  yield takeEvery(UPDATE_ATTSCHEDULE, onUpdateAttSchedule);
}

export function* watchDeleteAttSchedule() {
  yield takeEvery(DELETE_ATTSCHEDULE, onDeleteAttSchedule);
}

export function* watchAddNewAttSchedule() {
  yield takeEvery(ADD_NEW_ATTSCHEDULE, onAddNewAttSchedule);
}

function* attScheduleSaga() {
  yield all([
    fork(watchGetAttSchedule),
    fork(watchDeleteAttSchedule),
    fork(watchUpdateAttSchedule),
    fork(watchAddNewAttSchedule)
  ]);
}

export default attScheduleSaga;
